<template>
  <v-row id="login-page" column>
    <div class="logo text-xs-center mb-4">
      <p class="display-1 primary--text">
        {{ resx.messages.loginWelcomeTitle }}
      </p>
      <img src="@/assets/images/logo.png" width="100%" />
    </div>
    <v-col>
      <v-alert type="error" transition="fade-transition" :value="showMessage">
        {{ resx.messages.usernameOrPasswordIncorrect }}
      </v-alert>
      <div class="title mb-4 mt-4">{{ resx.labels.logInToYourAccount }}</div>
      <form @submit.prevent="login()" novalidate>
        <v-text-field
          data-vv-name="username"
          :data-vv-as="resx.labels.username"
          :label="resx.labels.username"
          :error-messages="errors.collect('username')"
          v-model="username"
          v-validate="'required'"
          required
          ref="input_username"
        >
        </v-text-field>
        <v-text-field
          :append-icon="passwordVisible ? 'visibility' : 'visibility_off'"
          @click:append="() => (passwordVisible = !passwordVisible)"
          data-vv-name="password"
          :data-vv-as="resx.labels.password"
          :label="resx.labels.password"
          :error-messages="errors.collect('password')"
          v-model="password"
          :type="!passwordVisible ? 'password' : 'text'"
          v-validate="'required'"
          required
        >
        </v-text-field>
        <v-row class="mt-4" column>
          <v-btn
            block
            :disabled="username && password && errors.any()"
            type="submit"
            color="primary"
          >
            {{ resx.labels.logIn }}
          </v-btn>
        </v-row>
      </form>
    </v-col>
    <BarLoader :isLoading="loading" :style="'margin-left: 335px; top: 550px; padding: 0;'"/>
  </v-row>
</template>

<script>
import service from "@/services/LoginService";
import BarLoader from "@/components/common/bar-loader.vue";

export default {
  components: {
    BarLoader
  },
  data() {
    return {
      username: "",
      password: "",
      showMessage: false,
      passwordVisible: false,
      loading: false
    };
  },
  mounted() {
    this.focusInputUsername();
  },
  methods: {
    async login() {
      setTimeout(() => {
        this.loading = true;
      }, 1000);
      try {
        this.showMessage = false;
        let response = await service.login({
          username: this.username,
          password: this.password

        });
        if (response.data) {
          this.$store.commit("login", response.data);
          this.$store.commit("connect", response.data);
          this.$router.replace({ name: "home" });
          // switch (this.$store.state.auth.user.roles[0]) {
          //   case this.$store.state.constants.roles.SYS_ADMIN:
          //   case this.$store.state.constants.roles.ADMIN:
          //   case this.$store.state.constants.roles.USER:
          //     this.$router.replace({ name: "contractorsCompany" });
          //     break;
          //   case this.$store.state.constants.roles.SYS_SUPERVISOR:
          //   case this.$store.state.constants.roles.SYS_BO:
          //     this.$router.replace({ name: "contractors" });
          //     break;
          //   case this.$store.state.constants.roles.SECURITY:
          //     this.$router.replace({ name: "search-contractor" });
          //     break;
          //   default:
          //     this.$router.replace({ name: "contractorsCompany" });
          //     break;
          // }
          this.loading = false;
        }
      } catch (err) {
        console.error(err);
        this.showMessage = true;
      } finally {
        this.loading = false;
      }
    },
    focusInputUsername() {
      this.$refs.input_username.focus();
    }
  }
};
</script>
<style lang="scss">
#login-page {
  padding: 92px 32px 32px 32px;

  .logo {
    width: 100%;
  }
}

.is-mobile:not(.is-tablet) {
  #login-page {
    padding: 0px 32px 32px 32px;
  }
}
</style>

